"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _color = _interopRequireDefault(require("../Components/styles/color"));
var _theme = _interopRequireDefault(require("../Components/styles/theme"));
var _RoundedButton = _interopRequireDefault(require("../Components/Buttons/RoundedButton"));
var _Row = _interopRequireDefault(require("../Components/Row"));
var _Column = _interopRequireDefault(require("../Components/Column"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
var Container = _styledComponents["default"].div.withConfig({
  displayName: "Container",
  componentId: "sc-142jlb7-0"
})(["min-width:200px;max-width:350px;display:", ";"], function (props) {
  return props.show ? 'block' : 'none';
});
var ParentContainer = _styledComponents["default"].div.withConfig({
  displayName: "ParentContainer",
  componentId: "sc-142jlb7-1"
})(["z-index:9;vertical-align:middle;background-color:", ";width:auto;height:auto;margin-left:auto;margin-right:auto;text-align:left;border-radius:8px;@media (max-width:600px){width:350px;}@media (max-width:360px){width:300px;}box-shadow:0 16px 32px rgba(47,56,62,0.13);"], _color["default"].white);
var BodyContainer = _styledComponents["default"].div.withConfig({
  displayName: "BodyContainer",
  componentId: "sc-142jlb7-2"
})(["padding:20px;max-height:260px;overflow:auto;"]);
var BottomBox = _styledComponents["default"].div.withConfig({
  displayName: "BottomBox",
  componentId: "sc-142jlb7-3"
})(["border-top:1px solid #D6D6D6;height:auto;padding:20px 10px;@media (max-width:600px){width:350px;}@media (max-width:360px){width:300px;}"]);
var FooterContainer = _styledComponents["default"].div.withConfig({
  displayName: "FooterContainer",
  componentId: "sc-142jlb7-4"
})(["width:100%;display:inline-block;"]);
var InfoModal = /*#__PURE__*/function (_React$Component) {
  _inherits(InfoModal, _React$Component);
  var _super = _createSuper(InfoModal);
  function InfoModal() {
    _classCallCheck(this, InfoModal);
    return _super.apply(this, arguments);
  }
  _createClass(InfoModal, [{
    key: "cancel",
    value: function cancel() {
      var cancelAction = this.props.cancelAction;
      if (cancelAction) {
        cancelAction();
      }
    }
  }, {
    key: "getFooter",
    value: function getFooter() {
      var _this = this;
      var cancelText = this.props.cancelText;
      return /*#__PURE__*/React.createElement(_Row["default"], {
        classNames: ['is-mobile']
      }, /*#__PURE__*/React.createElement(_Column["default"], null, /*#__PURE__*/React.createElement(_RoundedButton["default"], {
        onClick: function onClick() {
          return _this.cancel();
        },
        width: "118px",
        theme: _theme["default"].success,
        fill: true
      }, cancelText)));
    }
  }, {
    key: "render",
    value: function render() {
      var body = this.props.body ? this.props.body : null;
      var footer = this.getFooter();
      var jsxBody = this.props.jsxBody;
      return /*#__PURE__*/React.createElement(Container, {
        className: this.props.containerClass || '',
        show: this.props.show
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-container"
      }, /*#__PURE__*/React.createElement(ParentContainer, null, jsxBody || /*#__PURE__*/React.createElement(BodyContainer, {
        dangerouslySetInnerHTML: {
          __html: body
        }
      }), this.props.cancelText && /*#__PURE__*/React.createElement(BottomBox, null, /*#__PURE__*/React.createElement(FooterContainer, null, footer)))));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    value: // @ts-ignore
    function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return InfoModal;
}(React.Component);
var _default = InfoModal;
var _default2 = _default;
exports["default"] = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(Container, "Container", "/Users/crs/WebstormProjects/michelangelo/src/SharedComponents/InfoModal.js");
  reactHotLoader.register(ParentContainer, "ParentContainer", "/Users/crs/WebstormProjects/michelangelo/src/SharedComponents/InfoModal.js");
  reactHotLoader.register(BodyContainer, "BodyContainer", "/Users/crs/WebstormProjects/michelangelo/src/SharedComponents/InfoModal.js");
  reactHotLoader.register(BottomBox, "BottomBox", "/Users/crs/WebstormProjects/michelangelo/src/SharedComponents/InfoModal.js");
  reactHotLoader.register(FooterContainer, "FooterContainer", "/Users/crs/WebstormProjects/michelangelo/src/SharedComponents/InfoModal.js");
  reactHotLoader.register(InfoModal, "InfoModal", "/Users/crs/WebstormProjects/michelangelo/src/SharedComponents/InfoModal.js");
  reactHotLoader.register(_default, "default", "/Users/crs/WebstormProjects/michelangelo/src/SharedComponents/InfoModal.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();